import type { ThemeValueLegacy } from '@elfsight/configurator-controls';
import {
  formSettings as defaultFormSettings,
  fieldSettings,
  submitButtonSettings
} from '@elfsight/widget-form-builder/widget';
import { themeMapping } from './themeMapping';

export const theme = {
  type: 'light',
  accentColor: 'rgb(25, 123, 255)',
  errorColor: 'rgb(255, 56, 56)'
} as ThemeValueLegacy;

export const formSettings = {
  ...defaultFormSettings,
  visible: true,
  devicesVisible: 'allDevices',
  fields: [
    {
      id: 'l15167qq',
      type: 'email',
      ...fieldSettings.email
    }
  ],
  theme,
  ...themeMapping(theme),
  fieldLabelPosition: 'inside',
  submitButtonText: submitButtonSettings.submitButtonProps.text,
  widgetFooterTextStyle: {
    fontSize: 13
  }
} as const;
